/**
 * The widget's text size, stored per premise in RDS's `app_settings.gp_widget.font_size` and
 * picked by the customer in the widget admin. One of three steps; `medium` is the widget's
 * built-in sizing. Missing or invalid values return `null` rather than `medium`, like
 * `parseMaxWidth` — the caller decides what "unset" means. Overridable per embed with
 * `data-font-size`, using this same validation.
 */
export const FONT_SIZES = ["small", "medium", "large"] as const;
export type FontSize = (typeof FONT_SIZES)[number];

export function parseFontSize(value: unknown): FontSize | null {
  if (typeof value !== "string") return null;
  const normalized = value.trim().toLowerCase();
  return (FONT_SIZES as readonly string[]).includes(normalized) ? (normalized as FontSize) : null;
}
